module.exports = __webpack_public_path__ + "static/media/empty_shirt.3f51c73e.svg";